export default "::ng-deep .help-popover-button .dx-button-content{padding:0}";